import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getTokenFromStorage } from '@/utils/auth';
import { getClientNotifications, type ClientNotificationsResponse } from '@/api/beatlyApi';

/**
 * GET /app/v2/client/notifications — dashboard “needs attention” rows (client-only).
 */
export function useDashboardNotifications() {
  const { user } = useAuth();
  const token = getTokenFromStorage();
  const enabled = Boolean(token && user?.is_client === true);

  return useQuery({
    queryKey: ['dashboard', 'notifications', user?.team?.team_id],
    enabled,
    staleTime: 60_000,
    queryFn: async (): Promise<ClientNotificationsResponse> => {
      const t = token ?? '';
      return getClientNotifications(t);
    },
  });
}
